import React from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { TabItem, Tabs } from 'flowbite-react';

import BorrowerForm from './BorrowerForm';
import CrudPageLayout from '../../../layouts/CrudPageLayout';

import BorrowerService from '../../../services/BorrowerService';
import { useUiStore } from '../../../store';

const tabs = ['Borrower', 'Address', 'Employment', 'Declarations'];
const newBorrowerTabs = ['Borrower'];

export default function Borrower() {
  const { borrowerId, id } = useParams();
  const navigate = useNavigate();

  const isEdit = borrowerId !== 'new';
  const currentTabs = isEdit ? tabs : newBorrowerTabs;

  const notify = useUiStore((state) => state.notify);

  const queryClient = useQueryClient();

  const { data: borrower, refetch } = useQuery({
    queryKey: ['borrower', borrowerId],
    queryFn: () => BorrowerService.getBorrower(borrowerId),
    enabled: !!borrowerId && borrowerId !== 'new',
  });

  const { mutate: createBorrower, isPending: isCreating } = useMutation({
    mutationFn: (formValues) =>
      BorrowerService.createBorrower({ ...formValues, loanFileId: id }),
    onSuccess: async (newBorrower) => {
      console.log('Borrower created successfully');
      notify({ type: 'success', message: 'Borrower created successfully' });
      navigate(`/loan-files/${id}/borrowers/${newBorrower.id}`);
      queryClient.invalidateQueries({
        queryKey: ['borrowers', id],
      });
    },
    onError: (error) => {
      console.log(error);
      notify({ type: 'error', message: 'Error creating borrower' });
    },
  });

  const { mutate: updateBorrower, isPending: isUpdating } = useMutation({
    mutationFn: ({ formValues, borrowerId }) =>
      BorrowerService.updateBorrower({ formValues, id: borrowerId }),
    onSuccess: () => {
      console.log('Borrower updated successfully');
      refetch();
      notify({ type: 'success', message: 'Borrower updated successfully' });
    },
    onError: (error) => {
      console.log(error);
      notify({ type: 'error', message: 'Error updating borrower' });
    },
  });

  const isPending = isUpdating || isCreating;

  return (
    <CrudPageLayout
      title={
        isEdit
          ? `${borrower?.firstName || ''} ${borrower?.lastName || ''}`
          : 'New Borrower'
      }
    >
      <div className="flex flex-col gap-15">
        <Tabs>
          {currentTabs.map((tab) => {
            return (
              <TabItem title={tab} key={tab}>
                <BorrowerForm
                  currentTab={tab}
                  borrower={borrower}
                  updateBorrower={updateBorrower}
                  createBorrower={createBorrower}
                  isPending={isPending}
                />
              </TabItem>
            );
          })}
        </Tabs>
      </div>
    </CrudPageLayout>
  );
}
